import { Slide } from '../../types';

export function isLottie(slide: Slide): boolean {
  return slide?.imageEffect?.effectType === 'lottie';
}
